import React, { useEffect, useState } from 'react';
import Modal from '../../common/components/Modal/modal';
import { Formik } from 'formik';
import { leadRejectAndClose } from '../../common/constants/api';
import PopUp from '../../common/components/PopUp/PopUp';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';

const RejectLeads = ({ show, setShow, leadId, onSuccess }) => {
  const [progressPopUp, setProgressPopUp] = useState({
    type: 'loading',
    text: 'Rejecting lead ...!',
    dontClose: true
  });
  const [showPopup, setShowPopup] = useState(false);
  const [getConfirmation, setConfirmation] = useState(false);

  useEffect(() => {
    if (show) {
      setConfirmation(false);
    }
  }, [show]);
  const handleRejectionApi = values => {
    setShowPopup(true);
    setShow(false);
    setProgressPopUp({
      type: 'loading',
      text: 'Rejecting lead ...!',
      dontClose: true
    });
    leadRejectAndClose({ leadId, body: values?.rejectReason })
      .then(res => {
        setProgressPopUp({
          type: 'success',
          text: 'Lead Rejected Successfully ...!',
          dontClose: false
        });
        setTimeout(() => {
          setShowPopup(false);
          if (typeof onSuccess == 'function') {
            onSuccess();
          }
        }, 2000);
      })
      .catch(e => {
        setShowPopup(false);
      });
  };
  return (
    <div className="w-full">
      <Modal
        show={show}
        setShow={setShow}
        styleContainer={{
         maxWidth: '395px'
        }}
        title="Reject Application"
        titleStyle={{ color: 'black' }}
      >
        <hr className="border-black-1010" />
        <div className="w-full overflow-auto">
          {!getConfirmation && (
            <div className="w-full">
              <p className="font-roboto font-nromal text-black-1010 text-sm mt-3">
                Give a Reason to Reject the Documents
              </p>

              <p className="font-roboto font-normal text-grey-1003 text-xs mt-3 mb-2">
                Write a reason
              </p>
            </div>
          )}
          <Formik
            initialValues={{ rejectReason: '' }}
            validate={values => {
              const errors = {};
              if (!values.rejectReason) {
                errors.rejectReason = 'Required';
              } else if (values.rejectReason?.length < 10) {
                errors.rejectReason = 'Too Short!';
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setConfirmation(true);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
              <form onSubmit={handleSubmit}>
                {!getConfirmation && (
                  <div className="w-full">
                    <textarea
                      rows="3"
                      name="rejectReason"
                      value={values?.rejectReason}
                      onChange={handleChange}
                      className={`w-full px-2 py-3 rounded border  text-black-500 font-roboto text-xs ${
                        errors?.rejectReason && touched?.rejectReason
                          ? 'border-red-500'
                          : 'border-blue-1102'
                      }`}
                    />
                    <p
                      className={`mt-0.5 text-left font-roboto font-normal text-xs text-red-500 ml-1 h-4 ${!errors?.rejectReason &&
                        'invisible'}`}
                    >
                      {errors?.rejectReason}
                    </p>

                    <button
                      type="submit"
                      className="float-right clear-both px-3 mb-5 py-2 rounded mt-3 bg-green-1000 text-white font-roboto font-bold"
                    >
                      Submit
                    </button>
                  </div>
                )}
                {getConfirmation && (
                  <div className="w-full">
                    <p className="font-roboto font-normal text-xs mt-3 text-red-500">
                      The action cannot be undo! Are you sure to proceed?
                    </p>
                    <div className="float-right clear-both mt-2 flex">
                      <button
                        type="submit"
                        className="float-right clear-both px-3 mb-5 py-2 rounded mt-3 bg-green-1000 text-white font-roboto font-normal"
                        onClick={() => setShow(false)}
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="float-right clear-both px-3 mb-5 py-2 ml-1 rounded mt-3 bg-red-500 text-white font-roboto font-normal"
                        onClick={() => {
                          handleRejectionApi(values);
                        }}
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                )}
              </form>
            )}
          </Formik>
        </div>
      </Modal>
      <PopUp
        type={progressPopUp?.type}
        text={progressPopUp?.text}
        show={showPopup}
        setShow={setShowPopup}
        dontClose={progressPopUp?.dontClose}
      />
    </div>
  );
};

export default withErrorHandler(RejectLeads);
